import React from "react";

export default function UpArrowIcon(props) {
    return (
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.87235 0.25L15.6666 13.75L7.87234 5.75L0.078125 13.75L7.87235 0.25Z" fill="white"/>
        </svg>
    );
}